import React from "react";
import Productpage from "../../productpage2";

import SEO from "../../seo";

export default function ChiroCoilPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-04.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-01.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-02.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-03.png",
    ],
    productName: "Chiro Coil",
    // productLogo:
    //   "https://eclipsemattress.in/wp-content/uploads/2021/06/Eclipse_sub-brand_logo-02.png",
    descriptionTitle: "BONNELL TIGHT TOP",
    descriptionText:
      "Chiro Coil is deemed a pioneer mattress in the hotel industry. Constructed with Bonnell Spring coupled with HR foam and premium FR fabric, it's the most comfortable and yet a durable mattress perfect for hospitality usage. It has gone through numerous quality checks to ensure a great sleeping experience for you. ",
    // availableSizes: "6″, 8″ & 10",
    category: { title: "Hospitality Series", link: "/hospitality/" },
    points: [
      "UK grade premium fire-resistant (FR) fabric",
      "Combination of Chiropractic Bonnell Springs & HR Foam",
      "Available in Pillow Top & Euro Top Construction",
      "High durability",
      "Firm mattress",
    ],

    featuresText: [
      "HD Eclipse Soft Foam for quilting",
      "HD Eclipse Plush Foam",
      "Turkish Insulating Cotton Felt",
      "PP Mesh for durability",
      "Stonger border wire construction with butterfly M-Springs as edge support on perimeter",
      "Chiropractic Bonnell Spring",
      // "Good for people who have long sitting hours at work",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-06.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-07.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-08.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-09.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-10.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-12.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-13.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-14.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-15.png",
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-11.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/chiro-coil/CHIRO-Coil-05.png",

    relatedProducts: [
      {
        title: "Chiro Charge",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-charge.jpg",
        link: "/hospitality/chiro-charge/",
      },
      {
        title: "Chiro Charge PT",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-charge-pt.jpg",
        link: "/hospitality/chiro-charge-pt/",
      },
      {
        title: "Chiro Elite",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-elite.jpg",
        link: "/hospitality/chiro-elite/",
      },
    ],
    color: "#EFE5D8",
  };

  return (
    <div>
      <SEO
        title="Chiro Coil Hospitality Mattress | Eclipse Mattress"
        description="Pioneer mattress in the hotel industry - combining Bonnell Spings with HR foam and premium FR fabric with high durability for hospitality usage. The UK Grade FR Fabric is resistant to flames ensuring maximum safety of the hotel guests"
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-chirocoil.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
